import { defineStore } from 'pinia';

export interface MfaEligibilityResponse {
  eligible: boolean;
  reason?: string;
  factors?: string[];
}

export interface UserLoginState {
  email: string;
  // pageLoadUrl tracks the initial page load URL
  pageLoadUrl: string;
  password: string;
  shouldRememberEmail: boolean;
  verifyEmailHash?: string;
  emailSubmitResult: Record<string, any>; // Store the result from submitEmail API
  // NA-4357 MFA-direct password reset
  eligibility: MfaEligibilityResponse | null;
  pwdResetToken: string;
  pwdResetMfaVerified: boolean;
  resetPath: 'mfa-direct' | 'email' | null;
}

export default defineStore('userLogin', {
  // arrow function recommended for full type inference
  state: (): UserLoginState => ({
    email: '',
    pageLoadUrl: '',
    password: '',
    shouldRememberEmail: false,
    verifyEmailHash: '',
    emailSubmitResult: {},
    eligibility: null,
    pwdResetToken: '',
    pwdResetMfaVerified: false,
    resetPath: null,
  }),
});
